import React from 'react'
import {useRouteError, useNavigate} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

import {Button} from '~/components/general/button/Button'
import {Container} from '~/components/general/container/Container'
import {Typography} from '~/components/general/typography/Typography'
import {AuthLayout} from '~/components/layout/authLayout/AuthLayout'

export const ErrorPage: React.FC = () => {
  const error = useRouteError()
  const {t} = useTranslation<string>()
  const navigate = useNavigate()

  // Log error details for debugging
  if (error) {
    console.error('ErrorPage caught route error:', error)
  }

  return (
    <AuthLayout>
      <Container spacing={5} direction="column">
        <div>
          <h1>{t('Oops!')}</h1>
          <Typography size="xl">
            {t('Sorry, an unexpected error has occurred.')}
          </Typography>
        </div>
        <Button onClick={() => navigate('/', {replace: true})}>
          {t('Go home')}
        </Button>
      </Container>
    </AuthLayout>
  )
}
